import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'

// Against the Auth emulator with a `demo-` project these values are not checked,
// so development needs no real Firebase project. Production reads them from
// VITE_FB_* at build time.
const config = {
  apiKey: import.meta.env.VITE_FB_API_KEY ?? 'demo-api-key',
  authDomain: import.meta.env.VITE_FB_AUTH_DOMAIN ?? 'demo-matrix.firebaseapp.com',
  projectId: import.meta.env.VITE_FB_PROJECT_ID ?? 'demo-matrix',
  appId: import.meta.env.VITE_FB_APP_ID ?? '1:0:web:0',
}

export const app = initializeApp(config)
export const auth = getAuth(app)

// Point at the emulator on localhost. Must happen before any auth call.
//
// VITE_LIVE=1 turns it off while still serving from localhost, which is how a
// change to this panel gets looked at against the real account: the emulator
// has no Zoho connection and no model key, so every screen worth checking is
// a sign-in prompt.
const host = window.location.hostname
const wantsLive = import.meta.env.VITE_LIVE === '1'
export const isEmulator = !wantsLive && (host === 'localhost' || host === '127.0.0.1')

if (isEmulator) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true })
}
